export default __webpack_public_path__ + "static/media/EDISON_DSPP-release3-v06.b675b7ba.pdf";